export const paintingsList = [
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661793227/mp/mp-p1.jpg",
        link: "https://www.instagram.com/p/CHVOnR1HBqX/"
    },
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661793778/mp/mp-p2.jpg",
        link: "https://www.instagram.com/p/CX5sA3mPvYu/"
    },
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661793935/mp/mp-p3.jpg",
        link: "https://www.instagram.com/p/CLWjwRGh6Ue/"
    },
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661794121/mp/mp-p4.jpg",
        link: "https://www.instagram.com/p/CIVoA1Jhhul/"
    },
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661794245/mp/mp-p5.jpg",
        link: "https://www.instagram.com/p/CF6dGAkAlTa/"
    },
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661794342/mp/mp-p6.jpg",
        link: "https://www.instagram.com/p/CFM_ufeBNFW/"
    },
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661794425/mp/mp-p7.jpg",
        link: "https://www.instagram.com/p/CD9RKAtgrba/"
    },
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661794808/mp/mp-p8.jpg",
        link: "https://www.instagram.com/p/CCB_98MgKLa/"
    }
];